import { render } from "./VideoReview.vue?vue&type=template&id=6a2956b9&scoped=true"
import script from "./VideoReview.vue?vue&type=script&lang=js"
export * from "./VideoReview.vue?vue&type=script&lang=js"

import "./VideoReview.scss?vue&type=style&index=0&id=6a2956b9&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2956b9"]])

export default __exports__